export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Our Work", to: "/gallery" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/quote" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400";

export const SERVICES = [
  {
    num: "01",
    title: "Full Event Planning & Coordination",
    desc: "Every detail designed and delivered for you — concept, styling, suppliers, logistics and flawless coordination on the day.",
    image: "https://images.unsplash.com/photo-1624067056935-593eb6595294?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    num: "02",
    title: "Partial Event Planning & Coordination",
    desc: "You've started the plans — we refine them, source the right suppliers and handle the finer details.",
    image: "https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    num: "03",
    title: "On-the-Day Coordination",
    desc: "We manage the timeline, suppliers and running order on the day, so you can be fully present.",
    image: "https://images.unsplash.com/photo-1700514077430-3659e38eb5e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    num: "04",
    title: "Ushering Services",
    desc: "Professional, warm ushers who guide your guests with grace from arrival to send-off.",
    image: "https://images.unsplash.com/photo-1612599542558-f3022089fb38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const EVENT_TYPES = [
  "Weddings",
  "Private Celebrations",
  "Parties",
  "Corporate Events",
  "Cultural Celebrations",
  "Larger / Bespoke Events",
];

export const GALLERY_CATEGORIES = [
  "All", "Weddings", "Celebrations", "Corporate", "Décor", "Venues", "Behind the Scenes",
];

export const STAFF_ROLE_OPTIONS = [
  { value: "staff", label: "Staff (General)" },
  { value: "content_creator", label: "Content Creator" },
  { value: "decor", label: "Décor" },
  { value: "dj", label: "DJ" },
  { value: "usher", label: "Usher" },
  { value: "makeup_artist", label: "Make-up Artist" },
  { value: "social_media_manager", label: "Social Media Manager" },
  { value: "event_manager", label: "Event Manager" },
  { value: "super_admin", label: "Super Admin" },
];

export const DEFAULT_CONTENT = {
  hero_image: "https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  hero_media: [{ type: "image", url: "https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400" }],
  hero_overline: "Worldwide Event Planning & Coordination",
  hero_support: "Bespoke event planning and coordination for unforgettable celebrations worldwide.",
  home_intro_heading: "Celebrations, composed with intention.",
  home_intro_p1: "The most memorable events feel effortless — because every detail is considered long before your first guest arrives.",
  home_intro_p2: "We carry the planning, so you can be present for the moments that matter.",
  about_image: "https://images.unsplash.com/photo-1676103391619-8de758b28b53?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  about_intro: "DonoDidioevents is a worldwide event planning and coordination company, built on one belief — your celebration should belong entirely to you.",
  about_p1: "From weddings to milestones, corporate and cultural celebrations, we bring structure, creativity and calm to every stage — managing the details that turn a gathering into a memory.",
  about_p2: "Behind the scenes, our team works with quiet professionalism, so the day simply flows.",
  gallery_intro: "Photography and film from celebrations we've planned worldwide — the décor, the venues, the joy, and everything behind the scenes.",
  staff_login_image: "https://images.unsplash.com/photo-1698934641149-93431f3bd4f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  home_welcome_heading: "Welcome to the DonoDidio Circle",
  home_explore_label: "Explore",
  home_moments_overline: "Our Special Moments",
  home_moments_heading: "Celebrations we bring to life, from vision to the very last detail.",
  home_cat_weddings_label: "Weddings",
  home_cat_events_label: "Events",
  home_cta_heading: "Let's plan something",
  home_cta_highlight: "unforgettable.",
  home_cta_button: "Begin Your Journey",
  footer_tagline: "Your vision. Your occasion. Beautifully brought to life.",
  weddings_heading: "Weddings we've had the honour of planning.",
  weddings_intro: "Every love story is different — here are a few of the celebrations we've brought to life.",
  events_heading: "Events crafted for every occasion.",
  events_intro: "From milestones to corporate and cultural celebrations — a look at the events we've designed.",
  about_h1: "We plan. We manage. You celebrate.",
  about_h2: "Thoughtful planning, delivered with grace.",
  about_cta_heading: "Ready when you are.",
  services_h1: "Four ways we bring your event to life.",
  services_intro: "We tailor our involvement to exactly what you need — from full planning to coordination on the day.",
  services_occasions_heading: "Weddings, private celebrations, parties, corporate & cultural events — and everything bespoke.",
  gallery_h1: "A portfolio of unforgettable moments.",
  gallery_cta_heading: "Your celebration could be next.",
  faq_heading: "Questions, answered.",
  faqs: [],
  about_blocks: [
    { headline: "Meet Our Founder", body: "DonoDidio began with a simple belief — that every celebration should feel effortless for the people it's made for. Our founder's eye for detail and calm, considered approach shapes everything we do.", image: "/images/dono/p0847.jpeg" },
  ],
  media_hero_full: [{ type: "image", url: "/images/dono/p33f2.jpeg" }],
  media_mosaic: [
    { type: "image", url: "/images/dono/p0802.jpg" },
    { type: "image", url: "/images/dono/p0803.jpg" },
    { type: "image", url: "/images/dono/p0806.jpg" },
    { type: "image", url: "/images/dono/p0807.jpg" },
    { type: "image", url: "/images/dono/p0808.jpg" },
    { type: "image", url: "/images/dono/p0822.jpg" },
  ],
  media_carousel: [],
  moments_weddings_image: "/images/dono/p0807.jpg",
  moments_events_image: "/images/dono/p33f2.jpeg",
  home_cta_image: "/images/dono/p0859.jpeg",
};

export const CONTENT_FIELDS = {
  images: [
    { key: "hero_image", label: "Homepage Hero Image" },
    { key: "home_cta_image", label: "Homepage CTA Background" },
    { key: "about_image", label: "About Page Image" },
    { key: "staff_login_image", label: "Staff Login Image" },
  ],
  texts: [
    { key: "hero_overline", label: "Hero Overline", type: "input" },
    { key: "hero_support", label: "Hero Supporting Text", type: "textarea" },
    { key: "home_intro_heading", label: "Home Intro Heading", type: "input" },
    { key: "home_intro_p1", label: "Home Intro Paragraph 1", type: "textarea" },
    { key: "home_intro_p2", label: "Home Intro Paragraph 2", type: "textarea" },
    { key: "about_intro", label: "About Intro", type: "textarea" },
    { key: "about_p1", label: "About Paragraph 1", type: "textarea" },
    { key: "about_p2", label: "About Paragraph 2", type: "textarea" },
    { key: "gallery_intro", label: "Gallery Intro", type: "textarea" },
    { key: "home_welcome_heading", label: "Home · Welcome Heading", type: "input" },
    { key: "home_explore_label", label: "Home · Explore Button", type: "input" },
    { key: "home_moments_overline", label: "Home · Special Moments (overline)", type: "input" },
    { key: "home_moments_heading", label: "Home · Special Moments (heading)", type: "textarea" },
    { key: "home_cat_weddings_label", label: "Home · Weddings link label", type: "input" },
    { key: "home_cat_events_label", label: "Home · Events link label", type: "input" },
    { key: "home_cta_heading", label: "Home · Closing CTA heading", type: "input" },
    { key: "home_cta_highlight", label: "Home · Closing CTA highlight word", type: "input" },
    { key: "home_cta_button", label: "Home · Closing CTA button", type: "input" },
    { key: "footer_tagline", label: "Footer · Tagline", type: "textarea" },
    { key: "weddings_heading", label: "Weddings page · Heading", type: "input" },
    { key: "weddings_intro", label: "Weddings page · Intro", type: "textarea" },
    { key: "events_heading", label: "Events page · Heading", type: "input" },
    { key: "events_intro", label: "Events page · Intro", type: "textarea" },
    { key: "about_h1", label: "About · Main heading", type: "input" },
    { key: "about_h2", label: "About · Sub heading", type: "input" },
    { key: "about_cta_heading", label: "About · CTA heading", type: "input" },
    { key: "services_h1", label: "Services · Main heading", type: "input" },
    { key: "services_intro", label: "Services · Intro", type: "textarea" },
    { key: "services_occasions_heading", label: "Services · Occasions heading", type: "textarea" },
    { key: "gallery_h1", label: "Our Work · Main heading", type: "input" },
    { key: "gallery_cta_heading", label: "Our Work · CTA heading", type: "input" },
    { key: "faq_heading", label: "FAQs · Page heading", type: "input" },
  ],
};
